<template>
  <v-card flat class="transparent-bg">
    <!-- بخش انتخاب تم (Themes) -->
    <div class="mb-8">
      <h3 class="text-h6 font-weight-bold mb-4 primary--text d-flex align-center">
        <v-icon color="primary" class="mr-2 ml-2">mdi-palette</v-icon>
        انتخاب قالب نمایش
      </h3>
      
      <v-item-group v-model="localTheme" mandatory class="custom-flex-container">
        <v-item 
          v-for="theme in themesList" 
          :key="theme.id" 
          v-slot="{ active, toggle }" 
          :value="theme.id"
        >
          <div class="flex-item theme-item">
            <v-card
              :class="['theme-card transition-swing rounded-xl w-100', active ? 'active-card elevation-6' : 'elevation-2']"
              @click="toggle"
              ripple
            >
              <!-- هدر کارت برای تیک خوردن -->
              <div class="card-header d-flex justify-end pa-2 position-absolute w-100" style="z-index: 2;">
                <v-icon v-if="active" color="white" class="active-icon" size="24">mdi-check-circle</v-icon>
                <v-icon v-else color="grey lighten-1" size="24">mdi-circle-outline</v-icon>
              </div>

              <!-- تصویر تم -->
              <div class="img-container pa-1">
                <v-img
                  :src="theme.src"
                  contain
                  height="100"
                  class="rounded-lg"
                >
                  <template v-slot:placeholder>
                    <v-row class="fill-height ma-0" align="center" justify="center">
                      <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </div>

              <!-- عنوان تم -->
              <v-card-actions class="justify-center py-1 bg-blur" v-if="theme.title!==''">
                <span :class="['font-weight-medium text-body-2', active ? 'primary--text font-weight-bold' : 'grey--text text--darken-2']">
                  {{ theme.title}}
                </span>
              </v-card-actions>
            </v-card>
          </div>
        </v-item>
      </v-item-group>
    </div>

    <v-divider class="mb-8"></v-divider>

    <!-- بخش انتخاب چیدمان شبکه‌های اجتماعی (Layouts) -->
    <div>
      <h3 class="text-h6 font-weight-bold mb-4 primary--text d-flex align-center">
        <v-icon color="primary" class="mr-2 ml-2">mdi-view-grid-plus</v-icon>
        انتخاب چیدمان شبکه‌های اجتماعی
      </h3>
      
      <v-item-group v-model="localLayout" mandatory class="custom-flex-container">
        <v-item 
          v-for="layout in layoutsList" 
          :key="layout.id" 
          v-slot="{ active, toggle }" 
          :value="layout.id"
        >
          <div class="flex-item layout-item">
            <v-card
              :class="['layout-card transition-swing rounded-lg w-100 h-100', active ? 'active-card elevation-4' : 'elevation-1']"
              @click="toggle"
              ripple
            >
              <div class="pa-1 text-center position-relative h-100 d-flex flex-column justify-space-between">
                <v-icon v-if="active" color="primary" class="position-absolute" style="top: 8px; right: 8px; z-index: 4;" size="18">mdi-check-circle</v-icon>
                
                <v-img
                  :src="layout.src"
                  contain
                  height="60"
                  class="mb-2 mx-auto"
                ></v-img>
                
                <span :class="['text-caption font-weight-medium', active ? 'primary--text' : 'grey--text text--darken-1']">
                  {{ layout.title }}
                </span>
              </div>
            </v-card>
          </div>
        </v-item>
      </v-item-group>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "ThemeLayoutSelector",
  
  props: {
    value: {
      type: Object,
      default: () => ({ theme: "socialMobile1_ok", layout: "SocialGrid2" })
    }
  },

  data() {
    return {
      themesList: [
        { id: "socialMobile1_ok", title: "", src: "/media/socialmedia/1 (1).webp" },
        { id: "socialMobile2_ok", title: "", src: "/media/socialmedia/1 (2).webp" },
        { id: "socialMobile3_ok", title: "", src: "/media/socialmedia/1 (3).webp" },
        { id: "socialMobile4_ok", title: "", src: "/media/socialmedia/1 (4).webp" },
      ],
      layoutsList: [
        { id: "SocialExpandable", title: "آکاردئونی", src: "/media/socialmedia/1 (6).webp" },
        { id: "SocialRibbonList", title: "لیست ساده", src: "/media/socialmedia/1 (8).webp" },
        { id: "SocialList", title: "لیست خطی", src: "/media/socialmedia/1 (7).png" },
        { id: "SocialListGrouped", title: "لیست گروه‌بندی", src: "/media/socialmedia/1 (5).webp" },
        { id: "SocialGrid", title: "گرید ساده", src: "/media/socialmedia/1 (10).webp" },
        { id: "SocialGrid2", title: "گرید ساده 2", src: "/media/socialmedia/1 (9).webp" },
        { id: "SocialWarp", title: " گرید شناور", src: "/media/socialmedia/1 (11).webp" },
      ],
    };
  },

  computed: {
    localTheme: {
      get() {
        return this.value.theme;
      },
      set(val) {
        this.$emit("input", { ...this.value, theme: val });
      }
    },
    localLayout: {
      get() {
        return this.value.layout;
      },
      set(val) {
        this.$emit("input", { ...this.value, layout: val });
      }
    }
  }
};
</script>

<style scoped>
.transparent-bg {
  background: transparent !important;
}

/* ساختار Flexbox سفارشی */
.custom-flex-container {
  display: flex;
  flex-wrap: wrap;
  gap: 16px; /* فاصله بین آیتم‌ها */
  width: 100%;
}

.flex-item {
  display: flex;
}

/* واکنش‌گرایی برای Theme ها */
.theme-item {
  flex: 0 0 calc(50% - 8px); /* موبایل: 2 آیتم در هر ردیف */
}
@media (min-width: 600px) {
  .theme-item {
    flex: 0 0 calc(33.333% - 11px); /* تبلت: 3 آیتم */
  }
}
@media (min-width: 960px) {
  .theme-item {
    flex: 0 0 calc(25% - 12px); /* دسکتاپ: 4 آیتم */
  }
}

/* واکنش‌گرایی برای Layout ها */
.layout-item {
  flex: 0 0 calc(50% - 8px); /* موبایل: 2 آیتم در هر ردیف */
}
@media (min-width: 600px) {
  .layout-item {
    flex: 0 0 calc(33.333% - 11px); /* تبلت: 3 آیتم */
  }
}
@media (min-width: 960px) {
  .layout-item {
    flex: 0 0 calc(16.666% - 14px); /* دسکتاپ: 6 آیتم در ردیف اول، بقیه می‌شکنند خط بعد */
  }
}

/* افکت‌های هاور و اکتیو */
.theme-card, .layout-card {
  border: 2px solid transparent;
  cursor: pointer;
}
.theme-card {
  background: rgba(255, 255, 255, 0.8) !important;
  backdrop-filter: blur(10px);
}
.layout-card {
  background: #ffffff;
  border-width: 1.5px;
}

.theme-card:hover, .layout-card:hover {
  transform: translateY(-5px);
}
.theme-card:hover {
  box-shadow: 0 12px 20px -10px rgba(25, 118, 210, 0.3) !important;
}
.layout-card:hover {
  border-color: rgba(25, 118, 210, 0.3);
}

.active-card {
  border-color: #1976d2 !important;
}
.theme-card.active-card {
  background: rgba(25, 118, 210, 0.05) !important;
}
.layout-card.active-card {
  background: rgba(25, 118, 210, 0.03) !important;
}

.img-container {
  background: #f8f9fa;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.bg-blur {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(5px);
  border-top: 1px solid rgba(0,0,0,0.05);
}

.active-icon {
  background-color: #1976d2;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  z-index: 2;
}
</style>
